import * as yup from 'yup'
import freeDomains from './free-domains'

yup.addMethod(yup.string, 'noBlockedEmail', function(message:string) {
  return this.test({ name: 'noBlockedEmail', message, test: (value: string | null | undefined) => {
    if (!value) return true
    const i = value.indexOf('@')
    if (i < 0) return true
    const domain = value.substr(i + 1)
    // const tmp = !freeDomains[domain]
    return !freeDomains[domain]
  }})
})



